// extracted by mini-css-extract-plugin
export var asideContainer = "subNavigationAside-module--asideContainer--9ef4a";
export var backButton = "subNavigationAside-module--backButton--3fc5b";
export var bounce = "subNavigationAside-module--bounce--1a7e8";
export var btnFacebook = "subNavigationAside-module--btn-facebook--e07a6";
export var btnLinkedin = "subNavigationAside-module--btn-linkedin--31efa";
export var btnWechat = "subNavigationAside-module--btn-wechat--8504f";
export var btnWrap = "subNavigationAside-module--btnWrap--3bb67";
export var btnXing = "subNavigationAside-module--btn-xing--0ca9e";
export var btnYoutube = "subNavigationAside-module--btn-youtube--10f48";
export var cameraAccessoriesListingPager = "subNavigationAside-module--cameraAccessoriesListingPager--39247";
export var container = "subNavigationAside-module--container--c69ff";
export var fadeIn = "subNavigationAside-module--fadeIn--96373";
export var grid = "subNavigationAside-module--grid--f5373";
export var icon = "subNavigationAside-module--icon--3bb83";
export var iconText = "subNavigationAside-module--icon-text--13188";
export var mail = "subNavigationAside-module--mail--e6532";
export var mobileTeasers = "subNavigationAside-module--mobileTeasers--440c2";
export var navElementsCommon = "subNavigationAside-module--navElementsCommon--8227f";
export var nestedContentTeaser = "subNavigationAside-module--nestedContentTeaser--603bc";
export var newsDetailWrap = "subNavigationAside-module--newsDetailWrap--06c88";
export var oneColumn = "subNavigationAside-module--oneColumn--1f12a";
export var phone = "subNavigationAside-module--phone--b9316";
export var printer = "subNavigationAside-module--printer--16b9e";
export var reducedWidth = "subNavigationAside-module--reducedWidth--539f8";
export var teaserBottomContent = "subNavigationAside-module--teaserBottomContent--dbffe";
export var textCap = "subNavigationAside-module--textCap--7c723";
export var twoColumn = "subNavigationAside-module--twoColumn--b1150";